import React, {Component} from 'react';
import PropTypes from 'prop-types';

class Countdown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      time: props.time,
    };

    this.timer = false;
  }

  componentDidMount() {
    this.timer = setInterval(() => this.countDown(), 1000);
  }

  countDown(){
    const {time} = this.state;

    this.setState({
      time: time-1,
    }, () => {
      if(this.state.time <= 0){
        this.props.handlerTimerCountedDown();
        clearInterval(this.timer);
      }
    });
  }

  static secondsToTime(secs) {
    let divisiorForMinutes = secs % (60 * 60);
    let divisiorForSeconds = divisiorForMinutes % 60;

    let minutes = Math.floor(divisiorForMinutes / 60);
    let seconds = Math.ceil(divisiorForSeconds);

    return Countdown.formatTimer(minutes, seconds)
  }

  static formatTimer(m, s){
    return [
      m <= 9 ? '0'+m : m,
      s <= 9 ? '0'+s : s,
    ].join(':')
  }

  render() {
    const {time} = this.state;

    return (
      <span>{Countdown.secondsToTime(time)}</span>
    )
  }
}

Countdown.propTypes = {
  time: PropTypes.number.isRequired,
  handlerTimerCountedDown: PropTypes.func.isRequired,
};

export default Countdown;
